import React from 'react';
import { getSpanishWeekdayShort } from './utils';
import { HolidayDayMarker } from './HolidayDayMarker';

type Props = {
  dateString: string;
  highlighted: boolean;
  editMode?: boolean;
  showDate?: boolean;
  isSmallScreen?: boolean;
  isBlocked?: boolean;
  actionModeActive?: boolean;
  blockadeReason?: string | null;
};

const DayHeader: React.FC<Props> = ({ dateString, highlighted, editMode = false, showDate = false, isSmallScreen = false, isBlocked = false }) => {
  const [yy, mm, dd] = dateString.split('-').map(Number);
  const date = new Date(yy, (mm || 1) - 1, dd || 1);
  const highlightClass = highlighted ? (editMode ? 'day-header-highlight' : 'day-header-highlight-schedule') : '';
  const highlightBg = isSmallScreen
    ? '#ffffff'
    : (highlighted ? 'rgb(186, 185, 187)' : '#ffffff');

  const blockedBackground = isBlocked
    ? `repeating-linear-gradient(-45deg, rgba(212, 208, 224, 1), rgba(212, 208, 224, 1) 5px, #e5e2ef 5px, #e5e2ef 10px)`
    : highlightBg;

  return (
    <div
      className={`group p-2 border-r-2 border-white sticky top-0 z-40 text-left font-semibold min-w-0 overflow-hidden ${highlightClass} ${isBlocked ? 'opacity-80' : ''}`}
      // `--psi-sticky-top`: alto de la barra fija de la app mobile (la define `PwaShell`); en la web no existe y vale 0.
      style={{ background: blockedBackground, top: 'var(--psi-sticky-top, 0px)' }}
    >
      {(() => {
        const normalFormat = `${getSpanishWeekdayShort(date)} ${date.getDate()} ${date.toLocaleDateString('es-ES', { month: 'short' })}`;
        if (editMode) {
          const text = showDate ? normalFormat : getSpanishWeekdayShort(date, true);
          return <span className="whitespace-nowrap overflow-hidden text-ellipsis block min-w-0" title={text}>{text}</span>;
        }
        if (isSmallScreen) {
          // Google Calendar style: single letter + number stacked
          const letter = getSpanishWeekdayShort(date).charAt(0).toUpperCase();
          const isToday = (() => {
            const now = new Date();
            return date.getDate() === now.getDate() && date.getMonth() === now.getMonth() && date.getFullYear() === now.getFullYear();
          })();
          return (
            <div className="flex flex-col items-center gap-px py-0.5 leading-none">
              <span style={{ fontSize: '0.6rem', color: isToday ? '#6D57BC' : '#9ca3af', fontWeight: 700, textTransform: 'uppercase' }}>{letter}</span>
              <span style={{
                fontSize: '0.85rem',
                fontWeight: 700,
                color: isToday ? '#ffffff' : '#374151',
                background: isToday ? '#6D57BC' : 'transparent',
                borderRadius: '50%',
                width: '1.4rem',
                height: '1.4rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>{date.getDate()}</span>
              <HolidayDayMarker date={dateString} variant="dot" />
            </div>
          );
        }
        const isToday = (() => {
          const now = new Date();
          return date.getDate() === now.getDate() && date.getMonth() === now.getMonth() && date.getFullYear() === now.getFullYear();
        })();
        return (
          <>
            <span
              className="whitespace-nowrap overflow-hidden text-ellipsis block min-w-0"
              title={normalFormat}
              style={isToday ? { color: '#6D57BC' } : undefined}
            >
              {normalFormat}
              {isToday && <span style={{ display: 'inline-block', width: '6px', height: '6px', borderRadius: '50%', background: '#6D57BC', marginLeft: '5px', verticalAlign: 'middle', marginBottom: '2px' }} />}
            </span>
            <HolidayDayMarker date={dateString} />
          </>
        );
      })()}
    </div>
  );
};

export default DayHeader;


